<template>
  <ContentContainer>
    <h3 class="font-semibold font-display text-heading-h1-mobile md:text-heading-h1">
      {{ $t('home.estimate') }}
    </h3>

    <CalculatorElement class="mt-16 md:mt-24" />
  </ContentContainer>
</template>

<script>
import ContentContainer from "@/components/ui/ContentContainer.vue";
import CalculatorElement from "@/components/Forms/Calculator/CalculatorElement.vue";

export default {
  components: {
    CalculatorElement,
    ContentContainer,
  },
}
</script>
